module.exports = __webpack_public_path__ + "07_2x.jpg?a9b43ef9462fa331b3bcff9c4eb7749b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/07_2x.jpg
// module id = 81
// module chunks = 0